module.exports = __webpack_public_path__ + "static/media/FileTime.7fed75e3.svg";